module.exports = __webpack_public_path__ + "img/speed-intense.84f9f3a3.svg";